import React from 'react';
import { Container, Typography, Box, Link } from '@mui/material';
import { Trans } from '@lingui/react/macro';
import { Link as RouterLink } from 'react-router';

const TermsPage: React.FC = () => {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h3" gutterBottom>
                <Trans>Terms of Service</Trans>
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography>
                    <Trans>
                        By using this application, you agree to use it in accordance with applicable laws and our policies. You are responsible for maintaining the security of your account.
                    </Trans>
                </Typography>
                <Typography>
                    <Trans>
                        The service is provided “as is”. We may modify these terms from time to time. Continued use constitutes acceptance of the updated terms.
                    </Trans>
                </Typography>
                <Box>
                    <Link component={RouterLink} to="/privacy"><Trans>Privacy Policy</Trans></Link>
                </Box>
            </Box>
        </Container>
    );
};

export default TermsPage;
